import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnackbarType } from './snackbar.enum';
import { SnackbarService } from './snackbar.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  animations: [
    trigger('state', [
      transition(':enter', [
        style({opacity: 0}),
        animate('150ms ease' , style({
          opacity: 1,
        }))
      ]),
      transition(':leave', [
        animate('150ms ease', style({
          opacity: 0
        }))
      ])
    ])
  ]
})
export class SnackbarComponent implements OnInit {

  public type = SnackbarType.SUCCESS;
  public titleImage = '';
  public title = 'SUCCESS NOTIFICATION';
  public message = 'Success message here'

  public show = false;

  private snackbarSubscription: Subscription;

  constructor(private snackbarService: SnackbarService) { 
    this.titleImage = this.getTitleImage(this.type)
  }

  ngOnInit(): void {
    this.snackbarSubscription = this.snackbarService.snackbarState.subscribe(
      (state) => {
        this.show = state.show;
        this.type = state.type;
        this.titleImage = this.getTitleImage(state.type);
        this.title = state.title;
        this.message = state.message

        setTimeout(() => {
          this.show = false
        }, 10000)
      }
    )
  }

  ngOnDestroy(): void {
    this.snackbarSubscription.unsubscribe();
  }

  private getTitleImage(type: string) {
    return `snackbar-${type}.svg`;
  }

  public closeSnackbar() {
    this.show = false;
  }

}
